import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import {useThemeStore} from '@/store/themeStore'
import './assets/styles/reset.css'
import './assets/styles/tailwind.css'
import './assets/styles/custom.css'
import {useAuthStore} from './store/authStore'
import Toast, {PluginOptions, POSITION} from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import '@mdi/font/css/materialdesignicons.min.css'
import {createPinia} from 'pinia'
import '@mdi/font/css/materialdesignicons.css'

// Создаем приложение.
const app = createApp(App);

// Делаем роутер доступным через $router во всех компонентах
app.config.globalProperties.$router = router;

// Подключаем хранилища состояния.
const pinia = createPinia();
app.use(router);
app.use(pinia);

// Подключаем всплывающие уведомления.
const toastOptions: PluginOptions = {
    position: POSITION.BOTTOM_RIGHT,
};
app.use(Toast, toastOptions);

// Инициализация фронтенда.
async function startFrontendApp() {
    // Загружаем тему приложения (темная/светлая).
    const themeStore = useThemeStore();
    themeStore.loadTheme();

    // Запускаем инициализацию авторизации в фоне.
    // Роутер дождется ее при переходе на защищенные страницы.
    const authStore = useAuthStore();
    authStore.initAuth();

    app.mount('#app');
}

startFrontendApp().catch((error) => {
    console.error('Failed to start frontend App:', error)
})
